<template>
  <v-dialog max-width="550px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Trader Config</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <r-item-trader-mode :model.sync="model.mode"/>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field label="Active Orders:" v-model.number="model.activeOrders" hide-details/>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-checkbox v-model="model.sideMenu" label="Side Menu" hide-details/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <r-tutorial-dropdown :model.sync="model.tutorialAllow" :clearable="true" label="Tutorial Allow"/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <r-tutorial-dropdown :model.sync="model.tutorialBlock" :clearable="true" label="Tutorial Block"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <r-item-order-kind :models.sync="model.acceptOrders" label="Common Orders" :multiple="true"/>
          </v-col>
        </v-row>
        <v-expansion-panels class="mt-4">
          <r-item-order-panel :items.sync="model.customOrders" title="Custom Orders"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemTraderConfig} from "@/modules/redactor/models/item/trader/ItemTraderConfig";

import RItemOrderKind from "@/modules/redactor/views/item-order/r-item-order-kind.vue";
import RItemOrderPanel from "@/modules/redactor/views/item-order/r-item-order-panel.vue";
import RItemTraderMode from "@/modules/redactor/views/item/trader/r-item-trader-mode.vue";
import RTutorialDropdown from "@/modules/redactor/views/tutorial/r-tutorial-dropdown.vue";

export default {
  name: "r-item-trader-config",
  components: {RTutorialDropdown, RItemTraderMode, RItemOrderPanel, RItemOrderKind},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemTraderConfig(),
    rules: ViewRules.READONLY,
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemTraderConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}
</script>